import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/AppTypes";
import { ISCMApplyListSearch, ISCMApplyListDetail, ISCMApplyListStatistics, ISCMApplyListInsert, ISCMApplyListUpdate, ISCMSDcGoodsOne, ISCMSDcSearch, ISCMORVRMTransferSearch, ISCMORVRMTransferDetails } from "./applyListTypes";


export interface ISCMPage<T, S> extends IPage<T> {
    statistics: S
}


export interface IFmsShopUnitDetail {
    address: string,
    bentity: string,
    branch: string,
    branchList: string,
    code: string,
    contact: string,
    createTime: string,
    createUser: string,
    deleteFlag: string,
    enable: string,
    id: string,
    name: string,
    note: string,
    phone: string,
    shop: string,
    shopCode: string,
    shopList: string,
    shopName: string,
    status: string,
    tel: string,
    updateTime: string,
    updateUser: string,
    ver: string,
}

class ApplyListService {
    async page(searchVo: ISCMApplyListSearch) {
        const apiUrl = "/assets/apply/page";
        return await httpRequest.post<IPage<ISCMApplyListDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/assets/apply/findById/${id}`
        return await httpRequest.get<ISCMApplyListDetail>(apiUrl)
    }
    async insert(insertVo: ISCMApplyListInsert) {
        const apiUrl = '/assets/apply/insert'
        return await httpRequest.post<boolean>(apiUrl, insertVo)
    }
    async update(updateVo: ISCMApplyListInsert) {
        const apiUrl = '/assets/apply/update'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    async updateOrderNum(updateVo: any) {
        const apiUrl = '/assets/apply/updateOrderNum'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    async audit(updateVo: ISCMApplyListInsert) {
        const apiUrl = '/assets/applyProcess/audit'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    //下载模板
    async downloadTpl() {
        const apiUrl = "/assets/apply/transfer/downloadTpl";
        return await httpRequest.getFile<boolean>(apiUrl);
    }
}

export const applyListService = new ApplyListService();